module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8408/img/hubspot-tools-logo.png"